module.exports = __webpack_public_path__ + "img/arrow-left.a914eec7.svg";